enum OssaActionNames {
  NEWS = 'news',
}

export default OssaActionNames;
